import React, { useEffect, useState } from "react";
import NewsCards from "./NewsCards";
import RefreshIcon from "@mui/icons-material/Refresh";
import CardCarouselNews from "../../../Admin/Dashboard/CardCarouselNews";
import api from "../../../../API/axiosInstance";
import "./Crawler Dashboard/../../style/Crawler.css";
import NavBar from "../../../Admin/Dashboard/NavBar";
import { showToast } from "../toastUtils";
import "./Crawler Dashboard/../../style/toast.css";
import ReactProSidebar from "../../../Admin/Dashboard/ReactProSidebar";
import "../../../../styles/NewsSentiment.css";
import { useAuth } from "../../../../context/AuthContext";

export default function CrawledNews() {
  const { loading, isAuthenticated } = useAuth();

  const [totalPageCount, settotalPageCount] = useState(0);
  const [todayAndAllNews, settodayAndAllNews] = useState([]);
  const [showAll, setShowAll] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const [todayNewsCount, settodayNewsCount] = useState(0);
  const [totalNewsCount, settotalNewsCount] = useState(0);
  const [todaySentimentPercent, settodaySentimentPercent] = useState({});
  const [totalSentimentpercent, settotalSentimentpercent] = useState({});

  // ✅ FIXED: removed useCallback + token logic
  const fetchNewsData = async (page) => {
    setIsLoading(true);

    try {
      const response = await api.get(`/news/show`, {
        params: showAll ? { page, today: false } : { page, today: true },
        withCredentials: true,
      });

      if (response.status === 200) {
        settodayAndAllNews(response.data.news);
        settotalPageCount(response.data.totalPages);

        if (showAll) {
          settotalNewsCount(response.data.totalCount);
        } else {
          settodayNewsCount(response.data.totalCount);
        }
      }
    } catch (err) {
      console.error("Error fetching news data:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSentimentCounts = async () => {
    try {
      const url = showAll
        ? `/news/sentiment?today=false`
        : `/news/sentiment?today=true`;

      const response = await api.get(url, {
        withCredentials: true,
      });

      if (response.status === 200) {
        const { positive, negative } = response.data;

        const total = positive + negative;

        const sentimentPercentages = total
          ? {
              positivePercentage: ((positive / total) * 100).toFixed(2),
              negativePercentage: ((negative / total) * 100).toFixed(2),
            }
          : {
              positivePercentage: "0",
              negativePercentage: "0",
            };

        if (showAll) {
          settotalSentimentpercent(sentimentPercentages);
        } else {
          settodaySentimentPercent(sentimentPercentages);
        }
      }
    } catch (err) {
      console.error("Error fetching sentiment data:", err);
    }
  };

  const startCrawling = async () => {
    showToast(`Embarking on a News Hunt! 🌍✨`, "success");

    try {
      const response = await api.post(
        `/scraping/news`,
        {},
        { withCredentials: true },
      );

      if (response.status === 200) {
        showToast(`Headlines Unlocked! 🔓📰 Hunt Successful! 📡🗞️`, "success");
      } else {
        showToast(`Error! 📭🛑 The News Is Stuck in Limbo!`, "error");
      }
    } catch {
      showToast("Error! ⚠️ The News Engine Needs a Jumpstart!", "error");
    }
  };

  const startAnalysis = async () => {
    showToast("Diving into News Data! 📊🧠", "success");

    try {
      const response = await api.post(
        `/analysis/news`,
        {},
        { withCredentials: true },
      );

      if (response.status === 204) {
        showToast("Empty News Basket! 🧺🔒", "warn");
      } else if (response.status === 200) {
        showToast(
          "Analysis Adventure Complete! 🌍🗞️ The News Journey Ends! 🏁✨",
          "success",
        );
        setTimeout(() => window.location.reload(), 2000);
      }
    } catch {
      showToast("Something went wrong during analysis.", "error");
    }
  };

  const toggleNewsView = () => {
    setShowAll((prev) => !prev);
    setCurrentPage(1);
  };

  const refreshNews = () => {
    fetchNewsData(currentPage);
  };

  // ✅ FIXED: split effects
  useEffect(() => {
    fetchNewsData(currentPage);
  }, [currentPage, showAll]);

  useEffect(() => {
    handleSentimentCounts();
  }, [showAll]);

  // ✅ FIXED: moved AFTER hooks
  if (loading) return <div>Loading...</div>;
  if (!isAuthenticated) return <div>Unauthorized</div>;

  return (
    <div className="container">
      <NavBar />

      <main className="news-main">
        <div style={{ width: "100%", overflow: "auto" }}>

          {/* Header */}
          <h1
            className="basic-Header"
            style={{ padding: "20px 34px 10px 34px" }}
          >
            News Sentiment
          </h1>

          {/* Main Container */}
          <div className="news-sentiment-container">
            <CardCarouselNews />
            {/* Stats Container */}
            <div className="news-sentiment-stats-container">
              <div className="news-sentiment-stat-item">
                <span className="news-sentiment-quantity">
                  {showAll ? totalNewsCount : todayNewsCount}
                </span>
                <span className="news-sentiment-text">
                  {showAll ? "Overall News Counts" : "Today's News Counts"}
                </span>
              </div>

              <div className="news-sentiment-stat-item positive">
                <span className="news-sentiment-quantity">
                  {showAll
                    ? totalSentimentpercent.positivePercentage
                    : todaySentimentPercent.positivePercentage}
                  %
                </span>
                <span className="news-sentiment-text">Positive Sentiment</span>
              </div>

              <div className="news-sentiment-stat-item negative">
                <span className="news-sentiment-quantity">
                  {showAll
                    ? totalSentimentpercent.negativePercentage
                    : todaySentimentPercent.negativePercentage}
                  %
                </span>
                <span className="news-sentiment-text">Negative Sentiment</span>
              </div>
            </div>

            {/* Button Container */}
            <div className="news-sentiment-button-container">
              <button
                className="news-sentiment-button refresh-btn"
                onClick={refreshNews}
              >
                <RefreshIcon />
                Refresh
              </button>

              <button className="news-sentiment-button" onClick={startCrawling}>
                Get News
              </button>

              <button className="news-sentiment-button" onClick={startAnalysis}>
                Analyze News
              </button>

              <button
                className={`news-sentiment-button ${
                  !showAll ? "toggle-btn" : ""
                }`}
                onClick={() => toggleNewsView(currentPage)}
              >
                {showAll ? "Show Today's News" : "Show All News"}
              </button>
            </div>
          </div>

          {/* News Section Header */}
          <div className="news-sentiment-section-header">
            <h3 className="news-sentiment-section-title">
              {showAll ? "All News Articles" : "Today's News Articles"}
            </h3>
          </div>

          <NewsCards
            analysisData={todayAndAllNews}
            currentPage={currentPage}
            isLoading={isLoading}
            toggleNewsView={fetchNewsData}
            setCurrentPage={setCurrentPage}
            setShowAll={setShowAll}
            totalPageCount={totalPageCount}
          />
        </div>
      </main>

      <ReactProSidebar />
    </div>
  );
}
